<div><button [class]="insideClass" [disabled]="insideDisabled" (click)="clickEvent($event)">
    <ng-content></ng-content>
</button></div>
